import { location, onMount, reactive } from 'cdui-js';
import { DiFiNavBar } from '../../../../../components/DiFi/DiFiNavBar';
import { DiFiButton } from '../../../../../components/DiFi/DiFiButton';
import { DiFiResult } from '../../../../../components/DiFi/DiFiResult';
import { isW8benEmbeddedInApp, w8benUrlKeepEmbed } from './w8benEmbed';

export type W8BenResultProps = {
  class?: string;
};

const W8BenResult = () => {
  const state = reactive({
    result: false,
  });

  onMount(() => {
    state.result = location.query.result;
  });

  const embedded = isW8benEmbeddedInApp();
  const pageClass = embedded
    ? 'w8ben-result page-wrapper-no-header flex-column justify-space-between'
    : 'w8ben-result page-wrapper-with-header flex-column justify-space-between';

  return (
    <div class={pageClass.trim()} style="background-color: #F7F8FA;">
      {embedded ? null : (
        <DiFiNavBar title="W-8BEN确认" fixed onClickLeft={() => location.routeTo(w8benUrlKeepEmbed('/w8ben'))} />
      )}

      <div class="flex-column align-center gap-16px padding-x padding-t-XXL" style="width: 100%;">
        <DiFiResult result={state.result} title="W-8BEN确认" content="如果您的开户资料有修改，请联系我们" />
      </div>

      {embedded ? null : (
        <div class="padding-x padding-b-L">
          <DiFiButton
            text="知道了"
            onClick={() => {
              location.routeTo('/my');
            }}
          />
        </div>
      )}
    </div>
  );
};

export default W8BenResult;
